import React from 'react'
import { AutocompleteInput, Edit, SaveButton, SimpleForm, TextInput, Toolbar, translate } from 'react-admin'
import { containsRestrictedFieldName } from '../models/restrictedNames'
import { AssetTypeScopeInputs } from './AssetTypeScopeInputs'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.invalid} />
  </Toolbar>
)

const AssetCustomFieldEdit = ({ accessible, dispatch, recordLiveValues, roles, translate, ...props }) => {
  const toolbar = <SaveOnlyToolbar />
  const validateName = (value) =>
    !containsRestrictedFieldName(value) ? undefined : translate('main.restricted_field_name')

  return (
    <Edit {...props}>
      <SimpleForm toolbar={toolbar}>
        <TextInput source="name" resettable validate={validateName} />
        <AutocompleteInput
          source="type"
          choices={[
            { id: 'text', name: 'Text' },
            { id: 'date', name: 'Date' },
          ]}
        />
        <AssetTypeScopeInputs />
      </SimpleForm>
    </Edit>
  )
}

export default translate(AssetCustomFieldEdit)
